<template>
    <div class="mb-3 row">
      <label :for="item.id" class="col-sm-2 col-form-label">{{ item.name }}</label>
      <div class="col-sm-auto">
        <div v-for="option in item.options" :key="option.value" class="form-check form-check-inline">
          <input
            type="radio"
            class="form-check-input"
            :id="`${item.id}-${option.value}`"
            :name="item.id"
            :value="option.value"
            v-model="selectedOption"
            @change="handleChange"
          />
          <label :for="`${item.id}-${option.value}`" class="form-check-label">{{ option.name }}</label>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, watch } from 'vue';


  export default defineComponent ({
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    emits: ['updateValue'],
    setup(props, { emit }) {
      const selectedOption = ref(props.item.value ?? (props.item.options.length > 0 ? props.item.options[0].value : ''));
      console.log("selectoption ", selectedOption.value)

      
      watch(
        () => props.item.value,
        (newValue) => {
          selectedOption.value = newValue ?? '';
          console.log("selectoption updated to ", selectedOption.value);
        }
      );
      

      const handleChange = (event) => {
        const newValue = event.target.value;
        emit('updateValue', { id: props.item.id, value: newValue });
      };

      return {
        handleChange,
        selectedOption
      };
    }

  });
  </script>